module.exports = __webpack_public_path__ + "img/clock-fill.750168cc.svg";